import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/staff/o')({
  loader: () => ({
    crumb: 'Organisations',
  }),
})
